import {
    CollectionsInputs,
    CollectionKey,
    CollectionPlan
} from "@/components/usage-based-pricing-calculator/src/context/types";

export type CollectionsAnalyticsPayload = Record<CollectionKey, CollectionPlan>;

export const mapCollectionsValueToAnalyticsPayload = (
    collectionsInputs: CollectionsInputs
): CollectionsAnalyticsPayload => {
    return (
        Object.entries(collectionsInputs) as [
            CollectionKey,
            CollectionsInputs[CollectionKey]
        ][]
    )
        .filter(([, { selected }]) => selected)
        .reduce((acc, [key, { plan }]) => {
            acc[key] = plan;
            return acc;
        }, {} as CollectionsAnalyticsPayload);
};
